import React, { useEffect, useRef, useState } from 'react';
import './TechStackSection.css';
import { Link } from 'react-router-dom';

const techStacks = [
  {
    title: "Frontend",
    techs: [
      { name: "React", icon: "/tech/react.webp" },
      { name: "Vue", icon: "/tech/vue.webp" },
      { name: "Angular", icon: "/tech/angular.webp" },
      { name: "Webflow", icon: "/tech/webflow.webp" }
    ]
  },
  {
    title: "Backend",
    techs: [
      { name: "Node.js", icon: "/tech/node.webp" },
      { name: "Django", icon: "/tech/django.webp" },
      { name: "Java", icon: "/tech/java.png" },
      { name: "Python", icon: "/tech/python.webp" },
      { name: "Rails", icon: "/tech/rails.webp" },
      { name: ".Net", icon: "/tech/net.png" }
    ]
  },
  {
    title: "Mobile",
    techs: [
      { name: "Flutter", icon: "/tech/flutter.webp" },
      { name: "React Native", icon: "/tech/react.webp" },
    ]
  },
  {
    title: "System",
    techs: [
      { name: "AWS", icon: "/tech/aws.webp" },
      { name: "Azure", icon: "/tech/azure.webp" },
      { name: "GCP", icon: "/tech/gcp.webp" }
    ]
  },
  {
    title: "AI/DATA SCIENCE",
    techs: [
      { name: "Pytorch", icon: "/tech/pytorch.webp" },
      { name: "Mlflow", icon: "/tech/mlflow.webp" },
      { name: "DVC", icon: "/tech/dvc.webp" },
      { name: "CML", icon: "/tech/cml.webp" },
      { name: "Vertex", icon: "/tech/vertex.webp" }
    ]
  },
  {
    title: "Design",
    techs: [
      { name: "Figma", icon: "/tech/figma.webp" },
      { name: "Photoshop", icon: "/tech/photoshop.webp" },
      { name: "Illustrator", icon: "/tech/illustrator.webp" },
      { name: "Indesign", icon: "/tech/indesign.webp" }
    ]
  }
];

const TechStackSection = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const cardRefs = useRef([]);
  const previousScrollY = useRef(window.scrollY);
  const yOffsets = useRef(Array(techStacks.length).fill(0));

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    if (!isMobile) {
      const handleScroll = () => {
        const currentScrollY = window.scrollY;
        const deltaY = currentScrollY - previousScrollY.current;
        const direction = deltaY > 0 ? 'down' : 'up';

        cardRefs.current.forEach((ref, index) => {
          if (!ref) return;

          const isLeft = index % 3 === 0;
          const isRight = index % 3 === 2;

          if (isLeft || isRight) {
            const change = direction === 'down' ? -1.5 : 1.5;
            let newOffset = yOffsets.current[index] + change;
            newOffset = Math.max(-40, Math.min(40, newOffset));
            yOffsets.current[index] = newOffset;

            ref.style.transform = `translate3d(0, ${newOffset}px, 0)`;
          }
        });

        previousScrollY.current = currentScrollY;
      };

      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', checkMobile);
      };
    }

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, [isMobile]);

  const toggleDropdown = (index) => {
    setActiveDropdown(activeDropdown === index ? null : index);
  };

  return (
    <section className="tech-stack-section" id="tech-stack">
      <div className="container">
        <div className="tech-stack-header">
          <h2 className="black-title">THE TECH STACK THAT HELPS</h2>
          <h2 className="blue-title">MAXIMISE YOUR BUSINESS VALUE</h2>
        </div>

        {isMobile ? (
          <div className="tech-stack-dropdowns">
            {techStacks.map((stack, index) => (
              <div key={index} className="tech-dropdown">
                <div 
                  className="dropdown-header"
                  onClick={() => toggleDropdown(index)}
                >
                  <h3>{stack.title}</h3>
                  <span className="dropdown-icon">
                    {activeDropdown === index ? '−' : '+'}
                  </span>
                </div>
                {activeDropdown === index && (
                  <div className="dropdown-content">
                    <div className="tech-items">
                      {stack.techs.map((tech, i) => (
                        <div key={i} className="tech-icon">
                          <img src={tech.icon} alt={tech.name} />
                          <span>{tech.name}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <div className="tech-stack-grid">
            {techStacks.map((stack, index) => (
              <div
                key={index}
                ref={(el) => (cardRefs.current[index] = el)}
                className="tech-card"
              >
                <h3>{stack.title}</h3>
                <div className="tech-items">
                  {stack.techs.map((tech, i) => (
                    <div key={i} className="tech-icon">
                      <img src={tech.icon} alt={tech.name} />
                      <span>{tech.name}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}

        <Link to="/services">
          <button className="tech-btn">EXPLORE OUR SERVICES</button>
        </Link>
      </div>
    </section>
  );
};

export default TechStackSection;